var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp-nav-tips comp",class:_vm.data.cla},[_c('div',{staticClass:"bg-tit-text"},[_c('span',[_vm._v(_vm._s(_vm.data.tit))]),_c('p',[_vm._v(_vm._s(_vm.data.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }